import React, { useRef } from 'react';
import { useHistory } from 'react-router';
import { useTranslation } from '../../contexts/translation';
import { Columns } from '../../pages/CustomersProject/WorkSheetsList/Columns';
import { paintCellByTaskColor } from '../../pages/Tasks/utils/paintCellByColor';
import { paintRowByTaskColor } from '../../pages/Tasks/utils/paintRowByColor';
import { SisDataGrid } from '../table';
import { IDataGrid } from './AssetsDataGrid';
import { STORAGE_KEYS } from '../../utils/localStorageKeys';
import { dateFieldOptionsWithSerialization } from '../../utils/dates.types';
import { CustomerProjectsTasksWorkSheetsFilterData } from '../../pages/CustomersProject/Tabs/CustomerProjectsWorkSheetsTab';

interface CustomerProjectsIDataGrid extends IDataGrid {
  customerProjectId?: number;
  filterData: CustomerProjectsTasksWorkSheetsFilterData
  onDateFromChanged: (dateFrom: string | null) => void;
  onDateToChanged: (dateFrom: string | null) => void;
}

export const CustomerProjectsWorkSheetsDataGrid = ({
  data,
  handleEdit,
  customerProjectId,
  filterData,
  onDateFromChanged,
  onDateToChanged,
}: CustomerProjectsIDataGrid) => {
  const { translate } = useTranslation();
  const transFormName = 'WorkSheet.List';
  const history = useHistory();

  // Reference na dataGrid. Nutné např. kvůli ukládání nastavení.
  const dataGrid = useRef<any>(null);

  const onToolbarPreparing = (e) => {
    e.toolbarOptions.items.unshift({
      location: 'before',
      html: translate!('WorkSheets', transFormName),
    });

    e.toolbarOptions.items.unshift(
      {
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'add',
          type: 'default',
          stylingMode: 'contained',
          onClick: () => history.push({
            pathname: '/worksheets/new/',
            state: {
              customerProject: {
                customerProjectId: customerProjectId,
              },
              backRoute: `/customers-projects/edit/${customerProjectId}`
            },
          }),
        },
      }
    );

    e.toolbarOptions.items.unshift(
      {
        location: 'after',
        template: () => {
          return translate!('Date from', transFormName);
        },
      },
      {
        location: 'after',
        widget: 'dxDateBox',
        options: {
          ...dateFieldOptionsWithSerialization,
          value: filterData.dateFrom,
          onValueChanged: (e) => {
            onDateFromChanged(e.value);
          }
        },
      },
      {
        location: 'after',
        template: () => {
          return translate!('Date to', transFormName);
        },
      },
      {
        location: 'after',
        widget: 'dxDateBox',
        options: {
          ...dateFieldOptionsWithSerialization,
          value: filterData.dateTo,
          onValueChanged: (e) => {
            onDateToChanged(e.value);
          }
        },
      },
    );
  };

  return (
    <SisDataGrid
      dataGridRef={dataGrid}
      data={data}
      keyExpr={'id'}
      transFormName={transFormName}
      columns={Columns(handleEdit, translate)}
      onCellDblClick={(e) => handleEdit && handleEdit(e)}
      columnChooser={false}
      allowColumnResizing={true}
      allowColumnReordering={false}
      onToolbarPreparing={onToolbarPreparing}
      onRowPrepared={paintRowByTaskColor}
      onCellPrepared={paintCellByTaskColor}
      stateStoringKey={STORAGE_KEYS.CUSTOMER_PROJECT_WORKSHEETS.toString()}
    />
  );
};
